import { OneGroupT } from 'shared/api/types/services';
import ModelInfo, { InfoBoxesT } from 'shared/components/ModelInfo';

interface Props {
  data: OneGroupT['response'];
}

const Info = ({ data }: Props) => {
  const infoBoxes: InfoBoxesT = [
    {
      label: 'Name',
      type: 'text',
      value: data.name,
    },
    {
      label: 'Note',
      type: 'text',
      value: data.note,
    },
    {
      label: 'TG Link',
      type: 'copy-text',
      value: {
        label: data.link,
        valueToCopy: data.link,
      },
    },
    {
      label: 'Sheet Link',
      type: 'copy-text',
      value: {
        label: data.sheetLink,
        valueToCopy: data.sheetLink,
      },
    },
  ]

  return (
    <ModelInfo infoBoxes={infoBoxes} />
  );
};

export default Info;
